<template>
  <div class="main">
    <Audio />

    <Artwork v-if="size === 'medium'" />

    <a
      v-if="pod.itunes_url && size !== 'small'"
      :href="pod.itunes_url"
      class="itunes-url"
    >
      <IconApplePodcasts v-if="size === 'large'" />
      <template v-else>Apple Podcasts</template>
    </a>

    <div>
      <MetaInfo v-if="size !== 'small'" />

      <div>
        <PlayPause>
          <template slot="play">
            <IconPlayLegacy />
          </template>
          <template slot="pause">
            <IconPauseLegacy />
          </template>
        </PlayPause>

        <Rewind v-if="size === 'small'">
          <IconRewindLegacy />
        </Rewind>

        <TimeCurrent />

        <Waveform />

        <TimeTotal />

        <Mute v-if="size === 'small'" />

        <Speed v-if="size === 'small'" />
      </div>
    </div>
  </div>
</template>

<script>
import Artwork from './Artwork'
import Audio from './Audio'
import IconApplePodcasts from '../assets/svg/apple-podcasts.svg'
import IconPlayLegacy from '../assets/svg/play-legacy.svg'
import IconPauseLegacy from '../assets/svg/pause-legacy.svg'
import IconRewindLegacy from '../assets/svg/rewind-legacy.svg'
import MetaInfo from './MetaInfo'
import Mute from './Mute'
import PlayPause from './PlayPause'
import Rewind from './Rewind'
import Speed from './Speed'
import Store from '../store'
import TimeCurrent from './TimeCurrent'
import TimeTotal from './TimeTotal'
import Waveform from './Waveform'

export default {
  components: {
    Artwork,
    Audio,
    IconApplePodcasts,
    IconPauseLegacy,
    IconPlayLegacy,
    IconRewindLegacy,
    MetaInfo,
    Mute,
    PlayPause,
    Rewind,
    Speed,
    TimeCurrent,
    TimeTotal,
    Waveform
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return { store: Store }
  },
  computed: {
    pod () { return this.store.state.podcast }
  }
}
</script>
